import getApi from '../../api'

export const removeImportantInformation = (id: number) =>
  getApi().delete<void>(`/question_templates/${id}/important_informations`)
